import Vue from 'vue';
import Vuex from 'vuex';

import auth from '@/util/auth';
import { urls } from '@/util/config';

import router from '@/router';

Vue.use(Vuex);
const vm = Vue;

const store = new Vuex.Store({
    state: {
        currentTab: 'media',
        loggedIn: false,
        loggingIn: false,
        loginNotAuth: false,
        loginFailed: false,
        timedOut: false,
        refreshStatus: false,
        refreshStatusCharts: false,
        refreshStatusPacing: false,
        notificationsOpen: false,
        compareChartOpen: {
            media: false,
            website: false,
        },
        globalFilters: {
            source: 'All',
            fromDate: null,
            toDate: null,
        },
        globalSource: 'All',
        chartFilters: {
            Creative: null,
            Date: null,
            Placement: null,
        },
        chartViews: {
            Series: null,
            XValue: 'Date',
            dateGroup: 'Days',
        },
        chartData: {
        },
        pacingData: {
        },
        websiteData: {
            tiles: {},
            table: {},
        },
        notificationsData: {
        },
        newNotifications: false,
        numberOfNewNotifications: 0,
        filter: null,
        mediaSources: [],
    },
    mutations: {
        setCurrentTab(state, status) {
            // eslint-disable-next-line
            state.currentTab = status;
        },
        setLoggingIn(state, status) {
            // eslint-disable-next-line
            state.loggingIn = status;
        },
        setLoggedIn(state, status) {
            // eslint-disable-next-line
            state.loggedIn = status;
        },
        setLoginNotAuth(state, status) {
            // eslint-disable-next-line
            state.loginNotAuth = status;
        },
        setLoginFailed(state, status) {
            // eslint-disable-next-line
            state.loginFailed = status;
        },
        setTimedOut(state, status) {
            // eslint-disable-next-line
            state.timedOut = status;
        },
        setRefreshStatus(state, status) {
            // eslint-disable-next-line
            state.refreshStatus = status;
        },
        setRefreshStatusCharts(state, status) {
            // eslint-disable-next-line
            state.refreshStatusCharts = status;
        },
        setRefreshStatusPacing(state, status) {
            // eslint-disable-next-line
            state.refreshStatusPacing = status;
        },
        setNotificationsOpen(state, status) {
            // eslint-disable-next-line
            state.notificationsOpen = status;
        },
        setCompareOpen(state, {
            tab,
            status,
        }) {
            // eslint-disable-next-line
            state.compareChartOpen[tab] = status;
        },
        setNewNotifications(state, status) {
            // eslint-disable-next-line
            state.newNotifications = status;
        },
        setNumberOfNewNotifications(state, status) {
            // eslint-disable-next-line
            state.numberOfNewNotifications = status;
        },
        refreshPacingData(state, newData) {
            // eslint-disable-next-line
            state.pacingData = newData;
        },
        refreshDcmData(state, newData) {
            // eslint-disable-next-line
            state.chartData = newData;
        },
        refreshWebsiteData(state, newData) {
            // eslint-disable-next-line
            state.websiteData = newData;
        },
        refreshMediaSources(state, newData) {
            // eslint-disable-next-line
            state.mediaSources = newData;
        },
        refreshNotificationsData(state, newData) {
            // eslint-disable-next-line
            state.notificationsData = newData;
        },
        setGlobalSource(state, newValue) {
            // eslint-disable-next-line
            state.globalSource = newValue;
        },
        updateGlobalFilters(state, {
            name, value,
        }) {
            // eslint-disable-next-line
            state.globalFilters[name] = value;
        },
        updateChartFilters(state, {
            name, value,
        }) {
            // eslint-disable-next-line
            state.chartFilters[name] = value;
        },
        updateChartViews(state, {
            name, value,
        }) {
            // eslint-disable-next-line
            state.chartViews[name] = value;
        },
    },
    actions: {
        updateCurrentTab(context, {
            value,
        }) {
            context.commit('setCurrentTab', value);
        },
        setNewNotificationsTrue(context) {
            context.commit('setNewNotifications', true);
        },
        setNewNotificationsFalse(context) {
            context.commit('setNewNotifications', false);
        },
        loggingInTrue(context) {
            context.commit('setLoggingIn', true);
        },
        loggingInFalse(context) {
            context.commit('setLoggingIn', false);
        },
        logout(context) {
            context.commit('setLoggedIn', false);
        },
        login(context) {
            context.commit('setLoggedIn', true);
        },
        openNotifications(context) {
            context.commit('setNotificationsOpen', true);
        },
        closeNotifications(context) {
            context.commit('setNotificationsOpen', false);
        },
        openCompare(context, { tab }) {
            context.commit('setCompareOpen', {
                tab,
                status: true,
            });
        },
        closeCompare(context, { tab }) {
            context.commit('setCompareOpen', {
                tab,
                status: false,
            });
        },
        updateGlobalFilters(context, payload) {
            return new Promise((resolve) => {
                context.commit('updateGlobalFilters', payload);
                resolve();
            });
        },
        updateGlobalSource(context, payload) {
            context.commit('setGlobalSource', payload);
        },
        updateChartFilters(context, payload) {
            context.commit('updateChartFilters', payload);
        },
        updateChartViews(context, payload) {
            context.commit('updateChartViews', payload);
        },
        refreshAllData(context) {
            context.commit('setRefreshStatus', true);
            Promise.all([
                context.dispatch('refreshPacingData'),
                context.dispatch('refreshDcmData'),
                context.dispatch('refreshMediaSources'),
                context.dispatch('refreshWebsiteData'),
            ]).then(() => {
                context.commit('setRefreshStatusPacing', false);
                context.commit('setRefreshStatusCharts', false);
                context.commit('setRefreshStatus', false);
                context.commit('setRefreshStatusCharts', false);
            });
        },
        refreshPacingData(context) {
            context.commit('setRefreshStatusPacing', true);

            return new Promise((resolve) => {
                const getUrl = urls.PACING_DATA_URL;
                const params = {};

                if (context.state.globalFilters.source) {
                    params.mediaSource = context.state.globalFilters.source;
                }

                if (context.state.globalFilters.fromDate) {
                    params.dateFrom = context.state.globalFilters.fromDate;
                }

                if (context.state.globalFilters.toDate) {
                    params.dateTo = context.state.globalFilters.toDate;
                }

                const config = {
                    params,
                    headers: auth.getAuthHeader(),
                };

                if (auth.checkAuth()) {
                    vm.http.get(getUrl, config).then((res) => {
                        if (res.status === 200) {
                            context.commit('refreshPacingData', res.body);
                            resolve();
                        } else {
                            console.log('error in get pacing', res);
                        }
                    });
                } else {
                    context.commit('setTimedOut', true);
                    router.push({
                        name: 'Login',
                    });
                    resolve();
                }
            });
        },
        refreshDcmData(context) {
            context.commit('setRefreshStatusCharts', true);
            return new Promise((resolve) => {
                const getUrl = urls.DCM_DATA_URL;
                const params = {};

                if (context.state.globalFilters.source) {
                    params.mediaSource = context.state.globalFilters.source;
                }

                if (context.state.globalFilters.fromDate) {
                    params.dateFrom = context.state.globalFilters.fromDate;
                }

                if (context.state.globalFilters.toDate) {
                    params.dateTo = context.state.globalFilters.toDate;
                }

                const config = {
                    params,
                    headers: auth.getAuthHeader(),
                };

                if (auth.checkAuth()) {
                    vm.http.get(getUrl, config).then((res) => {
                        if (res.status === 200) {
                            context.commit('refreshDcmData', res.body);
                            resolve();
                        } else {
                            console.log('error in dcm get', res);
                        }
                    });
                } else {
                    context.commit('setTimedOut', true);
                    router.push({
                        name: 'Login',
                    });
                    resolve();
                }
            });
        },
        refreshWebsiteData(context) {
            context.commit('setRefreshStatusCharts', true);
            return new Promise((resolve) => {
                const getUrl = urls.WEBSITE_ANALYTICS_URL;
                const params = {};

                if (context.state.globalFilters.source) {
                    params.mediaSource = context.state.globalFilters.source;
                }

                if (context.state.globalFilters.fromDate) {
                    params.dateFrom = context.state.globalFilters.fromDate;
                }

                if (context.state.globalFilters.toDate) {
                    params.dateTo = context.state.globalFilters.toDate;
                }

                const config = {
                    params,
                    headers: auth.getAuthHeader(),
                };

                if (auth.checkAuth()) {
                    vm.http.get(getUrl, config).then((res) => {
                        if (res.status === 200) {
                            context.commit('refreshWebsiteData', res.body);
                            resolve();
                        } else {
                            console.log('error in website data get', res);
                        }
                    });
                } else {
                    context.commit('setTimedOut', true);
                    router.push({
                        name: 'Login',
                    });
                    resolve();
                }
            });
        },
        refreshMediaSources(context) {
            return new Promise((resolve) => {
                const config = {
                    headers: auth.getAuthHeader(),
                };

                if (auth.checkAuth()) {
                    vm.http.get(urls.MEDIA_SOURCES_URL, config).then((res) => {
                        if (res.status === 200) {
                            context.commit('refreshMediaSources', res.body);
                            resolve();
                        } else {
                            console.log('error in media sources get', res);
                        }
                    });
                } else {
                    context.commit('setTimedOut', true);
                    router.push({
                        name: 'Login',
                    });
                    resolve();
                }
            });
        },
        refreshNotificationsData(context) {
            const config = {
                headers: auth.getAuthHeader(),
            };

            const getUrl = `${urls.NOTIFICATIONS_URL}${localStorage.getItem('userId')}/`;

            if (auth.checkAuth()) {
                vm.http.get(getUrl, config).then((res) => {
                    if (res.status === 200) {
                        const newNotifications = res.body.notifications.filter(notification => (
                            new Date(localStorage.getItem('lastLogin')) <= new Date(notification.updated_at)
                        ));

                        if (newNotifications.length) {
                            context.commit('setNewNotifications', true);
                        }
                        context.commit('setNumberOfNewNotifications', newNotifications.length);

                        context.commit('refreshNotificationsData', res.body);
                    } else {
                        console.log('error in notification get', res);
                    }
                }).catch(e => console.log(e));
            } else {
                context.commit('setTimedOut', true);
                router.push({
                    name: 'Login',
                });
            }
        },
    },
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js